import { ApiProperty } from "@nestjs/swagger";
import { VendorPriceListDto } from "./vendor-price-list-create.dto";

export class VendorPriceListInfo{
    @ApiProperty()
    inActiveItems:number[]; 
    @ApiProperty()
    vendorPriceListData:VendorPriceListDto[];

    /**
     * 
     * @param inActiveItems 
     * @param vendorPriceListData 
     */
    constructor(inActiveItems:number[], vendorPriceListData:VendorPriceListDto[]){
        this.inActiveItems = inActiveItems;
        this.vendorPriceListData = vendorPriceListData;
    }
}